import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { lazy, Suspense, useEffect } from 'react';
import { Box, CircularProgress, CssBaseline } from '@mui/material';
import NavBar from './components/Navbar';
import FixedBtn from './components/global/FixedBtn';
import Footer from './components/Footer/Footer';
import ConsentBanner from './components/global/ConsentBanner';
import NotFound from './pages/NotFound';

// Pages
const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/About"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Hiring = lazy(() => import("./pages/Hiring"));
const Projects = lazy(() => import("./pages/Projects"));
const Project = lazy(() => import("./pages/Project"));
const Products = lazy(() => import('./pages/Products'));
const Subcategories = lazy(() => import('./pages/Subcategories'));
const ProductList = lazy(() => import('./pages/ProductList'));
const Service = lazy(() => import("./pages/Service"));
const Services = lazy(() => import("./pages/Services"));
const City = lazy(() => import("./pages/City"));
const Quote = lazy(() => import("./pages/Quote"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <>
        <CssBaseline />
        <FixedBtn />
        <NavBar />
        <ScrollToTop />
        <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress sx={{ color: '#b8975a' }} />
        </Box>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<Service />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<Project />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:categorySlug" element={<Subcategories />} />
            <Route path="/products/:categorySlug/:subcategorySlug" element={<ProductList />} />
            <Route path="/city/:id" element={<City />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <ConsentBanner />
      </>

    </div>
  );
}

export default App;
